export const translations = {
  actionDowngradeText: 'Downgrade',
  actionRejectText: 'Reject',
  actionText: 'Action',
  ageMonthsText: 'Age (months)',
  anyText: 'Any',
  applicationsText: 'Application(s)',
  applicationText: 'Application',
  assetManagementHeader: 'Asset Management',
  axlesText: 'Axle(s)',
  axleText: 'Axle',
  backButtonText: 'Back',
  beadText: 'Bead',
  bibtreadNextText: 'Bibtread Next',
  brakeSkidText: 'Brake Skid',
  camSpecNameColumnText: 'CAM Spec Name',
  camSpecDescriptionColumnText: 'CAM Spec Description',
  typeColumnText: 'Type',
  btnReportText: 'BTN Report',
  btnv4Text: 'BTN v4',
  createCAMSpecHeadingText: 'Create CAM Spec',
  cancelLinkText: 'Cancel',
  contactText: 'Contact',
  copyrightText: 'Copyright',
  customerAddress1Text: 'Address 1',
  customerAddress2Text: 'Address 2',
  customerCityStateZipText: 'Customer City, State & ZIP',
  customerCodeText: 'Customer Code',
  customerInformationHeader: 'Customer Information',
  customerNameText: 'Customer Name',
  disposalCodeText: 'Disposal Code',
  dispositionReturnText: 'Return',
  dispositionScrapText: 'Scrap',
  dispositionText: 'Disposition',
  editLinkText: 'Edit',
  exportText: 'Export',
  printSelectedText: 'Print Selected',
  homeText: 'Home',
  languageDropdownLabelText: 'Language',
  linerText: 'Liner',
  loadingCustomer_: 'Loading customer...',
  loginButtonText: 'Login',
  loginFailedText: 'Login failed.  Credentials could not be verified.',
  logoutButtonText: 'Logout',
  makesText: 'Makes(s)',
  maxCrownSizeText: 'Max Crown Size',
  maxShoulderSizeText: 'Max Shoulder Size',
  maxSidewallSizeText: 'Max Sidewall Size',
  michelinText: 'Michelin',
  nailRepairHeader: 'Nail Repairs',
  ntrAndAgeText: 'NTR & Age',
  ntrText: 'NTR',
  otherRepairHeader: 'Other Repairs',
  passwordLabelText: 'Password',
  repairLimitsHeader: 'Repair Limits',
  rNailShoulderSizeText: 'RNail Shoulder Size',
  roText: 'RO',
  rrText: 'RR',
  salespersonIdText: 'Salesperson ID',
  sectionRepairHeader: 'Section Repairs',
  saveLinkText: 'Save',
  sequenceNumberText: 'Sequence #',
  searchBySequenceNumText: 'Search by Sequence #',
  enterSequenceNumText: 'Enter Sequence #',
  seriesText: 'Series',
  zoneSetupText: 'Zone Setup',
  setThemeText: 'Set theme',
  settingsText: 'Settings',
  shipToText: 'Ship To',
  sizesText: 'Size(s)',
  specificationTypeText: 'Specification Type',
  spotText: 'Spot',
  totalCrownSectionText: 'Total Crown Section',
  totalNailText: 'Total Nail',
  totalRepairsText: 'Total Repairs',
  totalRNailCrownText: 'Total RNail Crown',
  totalRNailShoulderText: 'Total RNail Shoulder',
  totalSectionText: 'Total Section',
  totalShoulderSectionText: 'Total Shoulder Section',
  totalSidewallSectionText: 'Total Sidewall Section',
  treadsText: 'Tread(s)',
  typeText: 'Specification Type: ',
  usernameLabelText: 'Username',
  versionText: 'Version',
  selectAtleastOneValueErrorText: 'Please select at least 1 value',
  incorrectValuesText: 'Incorrect Values',
  incorrectValuesAlertText:
    'There are incorrect values highlighted on the page. The CAM Spec will not be saved until the values are corrected !',
  incorrectCombinationText: 'Invalid Combination',
  incorrectCombinationAlertText: 'Some Make, Series and Size combinations are not valid as per casing definitions referential.',
  criticalErrorText: 'Critical Error',
  criticalErrorAlertText: 'There was an error saving the data. Please try again.',
  camSaveSuccessText: 'Saved Successfully',
  camSaveSuccessAlertText: 'The changes to the CAM Spec were successfully saved.',
  exceedsTotalRepairErrorText: 'Exceeds Total Repair',
  exceedsTotalSectionErrorText: 'Exceeds Total Section',
  exceedWarningText: 'Exceeds Michelin Spec!',
  discardButtonText: 'Discard',
  continueButtonText: 'Continue',
  camSpecNameText: 'CAM Spec Name',
  camSpecDescText: 'CAM Spec Description',
  camSpecTypeText: 'CAM Spec Type',
  camCreateSuccessTitleText: 'Created',
  camCreateSuccessContentText: 'New CAM Spec created successfully.',
  addRepairLimitText: '+ Add Repair Limit',
  camSpecDetailsText: 'CAM Spec Details',
  camSpecsText: 'CAM Specs',
  noSpecificationLinesText: 'This CAM Spec does not have any specification lines yet.',
  activeText: 'Active',
  inactiveText: 'Inactive',
  deleteSpecLineText: 'Delete Spec Line',
  deleteLineText: 'Delete Line',
  specLineText: 'Spec Line',
  deleteSpecLineAlertText: 'CAM Spec Line deleted successfully',
  nameText: 'Name',
  camAddLineSuccessText: 'Added',
  camAddLineSuccessContentText: 'New CAM Spec line added successfully.',
  createCamSpecButtonText: 'Create CAM Spec',
  assignCamSpecsText: 'Assign CAM Specs',
  allText: 'All',
  invalidCamSpecName: 'CAM Spec Name already exists',
  userSetupGroups: 'Users & Groups',
  notificationHubText: 'Notification Hub',
  notificationsManagementText: 'Notifications Management',
  featureFlagsText: 'Feature Flags',
  resetPasswordText: 'Reset Password',
  resetPasswordConfirmationText: 'Are you sure you want to reset the password for this user {user}?',
  customerInformationText: 'Customer Information',
  cityText: 'City',
  associateDealerCustomersText: 'Associate Dealer Customers',
  customerSetupText: 'Customer Setup',
  customerStateProvinceText: 'State/Province',
  codeText: 'Code',
  statusColumnText: 'Status',
  customerText: 'Customer',
  customerPostalCodeText: 'Postal Code',
  customerCountryText: 'Country',
  emailAddressText: 'Email Address',
  phoneNumberText: 'Phone Number',
  faxNumberText: 'Fax Number',
  salesIdText: 'Sales ID',
  routeIdText: 'Route ID',
  enterpriseIdText: 'Enterprise ID',
  cnpjInfoText: 'CNPJ',
  casingCreditText: 'Casing Credit',
  casingHistoryText: 'Casing History',
  casingHistoryViewsText: 'Views',
  casingHistoryTableViewText: 'Table',
  casingHistoryTimelineViewText: 'Vertical timeline',
  casingHistoryLifecycleViewText: 'Lifecycle stages',
  casingHistorySelectViewText: 'Select one or more views to display casing history.',
  casingHistoryNewestFirstText: 'Recorded events, newest first.',
  casingHistoryCreationStageText: 'Creation',
  casingHistoryBackOfficeStageText: 'Back-office updates',
  casingHistoryShopFloorStageText: 'Shop-floor activity',
  casingHistoryStageExplanationText:
    'Events grouped by recorded activity, newest first in each group. These groups do not confirm production-stage completion.',
  casingHistoryRecordedEventsText: 'Recorded events',
  casingHistoryNoStageEventsText: 'No activity recorded in this group.',
  casingHistoryDateUnknownText: 'Date not recorded',
  casingHistoryActionUnknownText: 'Action not recorded',
  casingHistoryNotRecordedText: 'Not recorded',
  casingHistoryCasingCreatedText: 'Casing {identifier} created',
  casingHistoryWorkOrderCreatedText: 'Work Order {identifier} created',
  casingHistoryFromMobileAppText: 'from mobile app',
  casingHistoryShopFloorUnavailableText: 'Shop-floor history cannot be loaded until the dealer and work-order line are available.',
  casingHistoryBackOfficeUnavailableText: 'Back-office history cannot be loaded until the dealer and casing ID are available.',
  casingHistoryShopFloorLoadErrorText: 'Shop-floor history could not be loaded. The displayed history may be incomplete.',
  casingHistoryBackOfficeLoadErrorText: 'Back-office history could not be loaded. The displayed history may be incomplete.',
  casingHistoryBackOfficeSourceText: 'Back Office',
  casingPurchaseText: 'Casing Purchase',
  casingPurchaseSetupText: 'Casing Purchase Setup',
  purchasePriceText: 'Purchase Price',
  michelinBillToText: 'Michelin Bill-To',
  michelinShipToText: 'Michelin Ship-To',
  preferredTreadsText: 'Preferred Treads',
  casingGradeText: 'Casing Grade',
  freeRepairsText: 'Free Repairs',
  turnaroundTimeText: 'Turnaround Time',
  remainingTreadDepthMinandMaxText: 'Remaining Tread Depth Min and Max',
  brandText: 'Brand',
  rememberBrandText: 'Remember Brand',
  rememberCasingNoteText: 'Remember Casing Note',
  wheelProcessingText: 'Wheel Processing',
  customerRejectsText: 'Customer Rejects',
  stockRejectsText: 'Stock Rejects',
  scrapDisposalChargeText: 'Scrap Disposal Charge',
  scrapCasingAtPlantText: 'Scrap Casing at Plant',
  centralRejectText: 'Central Reject',
  includeScrapCasingsInCentralRejectText: 'Include Scrap Casings in Central Reject',
  finishedLabelText: 'Finished Label',
  rejectReturnLabelText: 'Reject/Return Label',
  rejectScrapLabelText: 'Reject/Scrap Label',
  barcodeLabelText: 'Barcode Label',
  viewCamText: 'View CAM Spec',
  exportCamText: 'Export CAM Spec',
  notesText: 'Notes',
  cnpjText: 'CNPJ',
  defaultRRText: 'Default RR',
  defaultROText: 'Default RO',
  cannotStartWithBtText: 'CAM cannot start with BT',
  customersText: 'Customers',
  UserGroupFilterLabelText: 'Search by User Group Name',
  SearchText: 'Search',
  UserGroupPlaceholderText: 'Enter User Group Name',
  UserGroupEmptyPlaceholderText: 'No User Groups found',
  userLockedText: 'User Locked',
  userUnlockedText: 'User Unlocked',
  saveDuplicateText: 'Save Duplicate',
  cancelText: 'Cancel',
  saveDuplicateSuccessAlertTitleText: 'Duplicate CAM Spec Saved',
  saveDuplicateSuccessAlertText: 'The CAM Spec has been duplicated successfully.',
  searchCAMSpecificationsHeadingText: 'Search CAM Specifications',
  assignToCustomerMenuText: 'Assign to Customer',
  searchByCAMSpecText: 'Search by CAM Spec',
  columnsButtonText: 'Show/Hide Data',
  viewAssignedCustomerListMenuText: 'View Assigned Customers',
  exceedsColumnText: 'Exceeds',
  usedByColumnText: 'Used By',
  createdOnColumnText: 'Created On',
  updatedOnColumnText: 'Updated On',
  createdByColumnText: 'Created By',
  updatedByColumnText: 'Updated By',
  duplicateCAMSpecMenuText: 'Duplicate CAM Spec',
  deleteCAMSpecMenuText: 'Delete CAM Spec',
  rtDotLabelText: 'RT-DOT',
  interfaceID1LabelText: 'Interface ID1',
  interfaceID2LabelText: 'Interface ID2',
  btmFlagText: 'BTM Flag',
  customerTypeColumnText: 'Type',
  searchByBTMFlagText: 'Search by BTM Flag',
  searchByStatusText: 'Search by Status',
  searchTypeLabelText: 'Search by Type',
  yesText: 'Yes',
  noText: 'No',
  plantAssignmentColumnText: 'Plant Assignment',
  incorrectValuesOnCustomerSaveAlertText:
    'There are incorrect values highlighted on the page. The Customer will not be saved until the values are corrected!',
  associateDealerText: 'Associate Dealer',
  associateDealerCustomerText: 'Associate Dealer Customer',
  defaultCustomerText: 'Default Customer',
  mandatoryMissingText: 'The following fields are mandatory: ',
  deleteCasingGradeTableConfirmText: 'Are you sure you want to delete the Casing Grade Specification?',
  invalidWorkflowPostsText: 'The following posts are marked as inactive (N) and cannot be used in workflows',
  // Email Setup translations
  emailSetupText: 'Email Setup',
  setupText: 'Setup',
  emailTypeText: 'Type',
  emailText: 'Email',
  locationText: 'Location',
  searchByNameText: 'Search by Name',
  selectEmailText: 'Select Email',
  addEmailText: '+ Add Email',
  selectTypeText: 'Select',
  selectLocationText: 'Select',
  emailSetupTypeRequiredText: 'Type is required.',
  emailSetupNameRequiredText: 'Name is required.',
  emailSetupEmailRequiredText: 'Email is required.',
  invalidEmailText: 'Please enter a valid email address.',
  emailSetupSavedText: 'Email setup saved successfully',
  emailSetupSaveErrorText: 'Error encountered while saving email setup',
  emailSetupDeleteText: 'Email setup deleted successfully',
  emailSetupDeleteErrorText: 'Error encountered while deleting the email setup',
  deleteEmailSetupConfirmText: 'Are you sure you want to delete this email setup?',
  discardChangesText: 'Discard Changes',
  okText: 'OK',
  onlyTheFirstNoteText: 'Note: Only the first ',
  recordsWillBeExportedText: ' records will be exported.',
  warningText: 'Warning!',
  clearSelectionText: 'Clear Filter',
  emptyTableText: 'No data available',
  deleteText: 'Delete',
  editText: 'Edit',
  unSaveChangesText: 'You have unsaved changes. Do you want to discard them?',
  emailTypeFilterText: 'Type',
  selectTypeFilterText: 'Select Type',
  inventoryText: 'Inventory',
  stockMovementHistoryText: 'Stock Movement History',
  stockManagementText: 'Stock Management',
  receiveInventoryText: 'Receive Inventory',
  adjustInventoryText: 'Adjust Inventory',
  searchByRawMaterialTypeText: 'Search By Raw Material Type',
  searchBySerialNumberText: 'Search By Serial Number',
  searchByDescText: 'Search By Description',
  stockMovementTypeText: 'Stock Movement Type',
  plantCodeText: 'Plant Code',
  plantNameText: 'Plant Name',
  searchByPlantText: 'Search By Plant',
  rawMaterialTypeText: 'Raw Material Type',
  descriptionText: 'Description',
  serialNumberText: 'Serial Number',
  quantityText: 'Quantity',
  updateDateText: 'Update Date',
  updateUserText: 'Update User',
  commentText: 'Comment',
  searchByStockMovementTypeText: 'Search By Stock Movement Type',
  totalAvailableStockText: 'Total Available Stock (Qty/Weight)',
  quantityWeightToReceiveText: 'Quantity/Weight to Receive',
  clearFormText: 'Clear Form',
  requiredFieldsText: 'Required Fields',
  zoneSetupUpdatedSuccessfullyText: 'Zone Setup Updated Successfully',
  // Access Denied page
  accessDeniedTitleText: 'Access Denied',
  accessDeniedBreadcrumbText: 'Access Denied',
  accessDeniedMessageText: 'You do not have the required permissions to view this page.',
  accessDeniedContactAdminText: 'Please contact your administrator if you believe this is an error.',
  accessDeniedHeadingText: 'OOPS...!',
  accessDeniedReasonText: 'You do not have the required permissions to access this page.',
  accessDeniedGoToHomeText: 'Go to Homepage',
  errorIllustrationAltText: 'Error illustration',
  returnToHomePageText: 'Return to Home Page',
  // Password expiration notification
  passwordExpiresTodayText: 'Your password expires today.',
  passwordExpirationModalTitle: 'Password Expiration Notice',
  passwordWillExpireText: 'Your password will expire in',
  wouldYouLikeToChangeItText: 'Would you like to change it now?',
  passwordExpiringSoonText: 'Password Expiring Soon',
  changePasswordText: 'Change Password',
  dismissText: 'Dismiss',
  // Product Import
  importProductDataText: 'Import Product Data',
  importingText: 'Importing...',
  importSuccessText: 'Product data imported successfully.',
  importPartialSuccessText:
    'Some product files failed to import. Successfully imported files have been archived; failed files have been moved to the error directory.',
  importFailedText: 'Product data import failed. No files were successfully imported. Please check the error directory.',
  noDataText: 'No product data files found. Please ensure files are present in the Azure storage directory.',
  importDisabledText: 'Product Import is currently disabled.',

  // Casing List — additional Show/Hide Data column fields (AC6)
  crnText: 'CRN',
  dueDateText: 'Due Date',
  workOrderDueDateText: 'Work Order Due Date',
  workOrderCreationDateText: 'Work Order Creation Date',
  receivedDateText: 'Received Date',
  selectCreationText: 'Select Creation ',
  searchByCasingCompleteDateText: 'Search by Casing Completion Date',
  workOrderHeaderStatusText: 'Work Order Header Status',
  completeDateText: 'Complete Date',
  currentSiteText: 'Current Site',
  rejectCodeText: 'Reject Code',
  rejectDateText: 'Reject Date',
  rejectPartNumberText: 'Reject Part Number',
  disposalChargeDescriptionText: 'Disposal Charge Description',
  scrapDescriptionText: 'Scrap Description',
  invoiceDateText: 'Invoice Date',
  invoiceNumberText: 'Invoice Number',
  packListIdText: 'Pack List ID',
  finishedProductTreadText: 'Tread',
  // Notification related translations
  notificationsText: 'Notifications',
  noNotificationsEmptyStateText: 'No notifications. When you have notifications you will see them here.',
  markAsReadText: 'Mark as read',
  closeText: 'Close',
  viewText: 'View',
  hereText: 'here',
  readText: 'Read',
  nafaCamSpecUpdatesTitleText: 'NAFA CAM spec updates',
  nafaCamSpecUpdatesDescriptionText: 'Show/hide notifications when a NAFA CAM specification is created, updated or deleted for your shop',
  // Templated CAM Spec notification bell messages. {0} = cam spec name, {1} = formatted date,
  // {LINK} = a non-linguistic marker (never rendered) that notification-bell.component.ts splits
  // on to inject the translated "here" link at the position each language's grammar requires.
  notificationCamSpecCreatedText: 'NAFA CAM Spec {0} was created on {1}. Click {LINK} to view the CAM Spec.',
  notificationCamSpecUpdatedText: 'NAFA CAM Spec {0} was updated on {1}. Click {LINK} to view the updated CAM Spec.',
  notificationCamSpecDeletedText: 'NAFA CAM Spec {0} was deleted on {1}.',
  // Relative-time labels for the notification bell timestamp (e.g. "5m", "2hr", "Yesterday").
  // {0} = numeric count, substituted the same way as the templates above.
  justNowText: 'just now',
  minutesAgoAbbrText: '{0}m',
  hoursAgoAbbrText: '{0}hr',
  yesterdayText: 'Yesterday',
  daysAgoText: '{0} days ago',
  notificationPreferenceSaveErrorText: 'Failed to save notification preference.',
  bannerManagementText: 'Banner notifications',
  bannerDisabledText: 'Enable isBannersEnabled flag to publish/receive banner notifications.',
  bannerGlobalHelpText: 'Banners are shown to all dealers on the home page. Open pages refresh every 30 minutes.',
  bannerCreateText: 'Create banner',
  bannerEditText: 'Edit banner',
  bannerSaveText: 'Save banner',
  bannerDeleteText: 'Delete banner',
  bannerActivateText: 'Activate',
  bannerDeactivateText: 'Deactivate',
  bannerRetryText: 'Retry',
  bannerLoadingText: 'Loading banners...',
  bannerTitleText: 'Banner title',
  bannerMessageText: 'Banner message',
  bannerStartText: 'Start',
  bannerEndText: 'End',
  bannerStartDateText: 'Start date',
  bannerStartTimeText: 'Start time',
  bannerEndDateText: 'End date',
  bannerEndTimeText: 'End time',
  bannerDateRequiredText: 'Enter a valid date.',
  bannerTimeRequiredText: 'Enter a valid time.',
  bannerChooseTimeText: 'Choose time',
  bannerHourText: 'Hour',
  bannerMinuteText: 'Minute',
  bannerPeriodText: 'AM/PM',
  bannerTimezoneHelpText: 'Enter date/time in your timezone ({timezone}). Converted UTC time will be shown alongside for reference.',
  bannerTimezoneText: 'Timezone: {timezone}',
  bannerActiveHelpLabelText: 'About banner activation',
  bannerActiveHelpText:
    'Active banners appear only within their start/end dates.\nUncheck to hide drafts/templates; check to publish on schedule.',
  bannerTemplateText: 'Mark as template',
  bannerTemplateHelpLabelText: 'About banner templates',
  bannerTemplateHelpText:
    'Templates keep their title and message for reuse and are never deleted automatically.\nOther banners are deleted 30 days after their end date.',
  bannerTemplateColumnText: 'Template',
  bannerStatusText: 'Status',
  bannerActionsText: 'Actions',
  bannerScheduledText: 'Scheduled',
  bannerLiveText: 'Live',
  bannerExpiredText: 'Expired',
  bannerEmptyText: 'No banners yet.',
  bannerLoadErrorText: 'Unable to load banners.',
  bannerRecordMissingText: 'This banner no longer exists.',
  bannerSaveSuccessText: 'Banner saved.',
  bannerSaveErrorText: 'Unable to save the banner.',
  bannerActivateSuccessText: 'Banner activated.',
  bannerActivateErrorText: 'Unable to activate the banner.',
  bannerDeactivateSuccessText: 'Banner deactivated.',
  bannerDeactivateErrorText: 'Unable to deactivate the banner.',
  bannerDeleteSuccessText: 'Banner deleted.',
  bannerDeleteErrorText: 'Unable to delete the banner.',
  bannerDeleteConfirmText: 'Permanently delete "{title}"?',
  bannerConflictTitleText: 'Banner schedule conflict',
  bannerReplaceConflictText:
    'This schedule overlaps the active banner {banners}.\nReplace it? The existing banner will be set to inactive.',
  bannerMultipleConflictText: 'This schedule overlaps several active banners: {banners}. Adjust the dates or resolve those banners first.',
  bannerPreviewText: 'Preview',
  bannerTitleRequiredText: 'Enter a banner title.',
  bannerTitleMaxLengthText: 'The banner title must be 200 characters or fewer.',
  bannerMessageRequiredText: 'Enter a banner message.',
  bannerMessageMaxLengthText: 'The banner message must be 500 characters or fewer.',
  bannerEndAfterStartText: 'The end must be after the start.',
  bannerAmbiguousTimeText: 'This time occurs twice because clocks go back. Choose another time.',
  bannerNonexistentTimeText: 'This time does not exist because clocks go forward. Choose another time.',
  bannerDiscardTitleText: 'Discard changes?',
  bannerDiscardConfirmText: 'Your changes have not been saved. Discard them?',
  addText: 'Add',
  resetChangesText: 'Reset Changes',
  saveText: 'Save',
  valueMustNotExceedText: 'Value must not exceed',
  uncheckedExternalApiEntityWarningText: 'Access permissions for unchecked entities will be removed when this configuration is saved',
  // Back office audit trail action labels
  boActionCreateWohText: 'Work Order Created',
  boActionCreateWolText: 'Casing Added to Work Order',
  boActionDeleteWolText: 'Casing Removed from Work Order',
  boActionDeleteWohText: 'Work Order Removed',
  boActionCustomerText: 'Customer Updated',
  boActionProductionCustText: 'Production Customer Updated',
  boActionWohnumText: 'Work Order Number Updated',
  boActionWohNumText: 'Work Order Number Updated',
  boActionDueDateText: 'Work Order Due Date Updated',
  boActionReceivedDateText: 'Work Order Receive Date Updated',
  boActionCrnText: 'Customer Reference Number Updated',
  boActionFiscalIdNumText: 'Fiscal ID Updated',
  boActionSiteText: 'Source Site Updated',
  boActionPlantText: 'Destination Plant Updated',
  boActionCircumferenceText: 'Circumference Updated',
  boActionTreadWidthText: 'Tread Width Updated',
  boActionDepthText: 'Tread Depth Updated',
  boActionRemainingTreadDepthText: 'Remaining Tread Depth Updated',
  boActionCasingNoteText: 'Casing Note Updated',
  boActionCasingValueText: 'Casing Value Updated',
  boActionCasingIdText: 'Casing Identifier Updated',
  boActionTreadTypeText: 'Tread Type Updated',
  boActionCureTypeText: 'Cure Type Updated',
  boActionMakeText: 'Tire Make Updated',
  boActionSeriesText: 'Tire Series Updated',
  boActionSizeText: 'Tire Size Updated',
  boActionApplicationText: 'Application Updated',
  boActionAxleText: 'Axle Position Updated',
  boActionMdotText: 'Manufacturer DOT Updated',
  boActionRtdotText: 'Retread DOT Updated',
  boActionBrandNumText: 'Brand Number Updated',
  boActionWheelColorText: 'Wheel Color Updated',
  boActionWheelTypeText: 'Wheel Type Updated',
  boActionGradeText: 'Grade Updated',
  boActionOverrideGradeText: 'Grade Override Applied',
  boActionCamText: 'Ignore CAM Validation Override Updated',
  boActionNtrText: 'Previous Retread Count Updated',
  boActionProcessCodeText: 'Process Code Updated',
  boActionRepairText: 'Repair Information Updated',
  boActionMiscChargeText: 'Miscellaneous Charge Updated'
};
